import React, { useEffect, useState } from "react";
import Layouts from "../../Layouts";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Pagination,
  Row,
  Select,
  Space,
  Table,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import BillingService from "../../../Services/BillingService";
import { useForm } from "antd/es/form/Form";
import moment from "moment";
import { FaSearch } from "react-icons/fa";
import { FaFilter } from "react-icons/fa6";
import PatientService from "../../../Services/PatientService";
import PatientQueue from "../VCPage/PatientQueue";
import patientqueue from "../../../Assets/Images/Svg/queue2.svg";
import dayjs from "dayjs";
import { SlArrowUp } from "react-icons/sl";
import { IoIosCloseCircle } from "react-icons/io";
import Draggable from "react-draggable";
import { MdKeyboardDoubleArrowUp } from "react-icons/md";
import convertUTCDateLocal from "../../../utils/convertToUtc";
import Preview from "../../../Assets/Icons/visibility.svg";
import BillingPrint from "./BillingPrint";

function Payments() {
  const [tableData, setTableData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form, setForm] = useForm();
  const [filterApplied, setFilterApplied] = useState(false);
  const [dataStatus, setDataStatus] = useState("Table");
  const [apiPayload, setApiPayload] = useState({});
  const [page, setPage] = useState(0);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [formData, setFormData] = useState({
    patientName: "",
    patientId: "",
    transactionId: "",
    serviceCode: "",
  });
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [isVerticalOpen, setIsVerticalOpen] = useState(true);
  const [billModal, setBillModal] = useState(false);
  const [billingRecord, setBillingRecord] = useState({});

  const storedLoginResult = localStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  useEffect(() => {
    getRecordList();
  }, []);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    form.resetFields();
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    getRecordList();
    setFormData({
      patientName: "",
      patientId: "",
      transactionId: "",
    });
    form.resetFields();
  };

  const formatDate = (date) => {
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const getRecordList = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const firstDate = new Date(year, month, 1);
    const lastDate = new Date(year, month + 1, 0);

    setFromDate(formatDate(firstDate));
    setToDate(formatDate(lastDate));

    let payload = {
      userId: loginResultObject.user.userId,
      clinic_id: loginResultObject.user.clinic_Id,
      fromDate: formatDate(firstDate),
      toDate: formatDate(lastDate),
      pageNumber: 0,
    };

    setApiPayload(payload);

    BillingService.BillingRecordsList(payload)
      .then((res) => {
        setTableData(res.data);
      })
      .catch((error) => {
        console.error("Error fetching billing records:", error);
      });

    BillingService.BillingCount(payload)
      .then((res) => {
        setPage(res.data.TOTAL_COUNT_STATUS);
      })
      .catch((error) => {
        console.error("Error fetching billing records:", error);
      });
  };

  const handleFinish = () => {
    const { patientId, patientName, transactionId } = formData;

    if (!patientId && !patientName && !transactionId) {
      message.error("Enter Any Details to filter");
      return;
    }
    let payload = {
      ...formData,

      userId: loginResultObject.user.userId,
      pageNumber: 0,
      fromDate: fromDate,
      toDate: toDate,
      clinic_id: loginResultObject.user.clinic_Id,
    };
    setApiPayload(payload);

    BillingService.BillingRecordsList(payload)
      .then((res) => {
        setTableData(res.data);
      })
      .catch((error) => {
        console.error("Error fetching billing records:", error);
      });

    BillingService.BillingCount(payload)
      .then((res) => {
        setPage(res.data.TOTAL_COUNT_STATUS);
      })
      .catch((error) => {
        console.error("Error fetching billing records:", error);
      });

    handleOk();
  };

  const handleMonthFilter = (value) => {
    const formattedDate = "01";
    const formattedMonth = value.format("MM");
    const formattedYear = value.format("YYYY");
    const fromDate = `${formattedMonth}/${formattedDate}/${formattedYear}`;
    const fromDateMoment = moment(fromDate, "MM/DD/YYYY");
    const lastDayOfMonth = fromDateMoment.endOf("month").format("MM/DD/YYYY");
    const toDate = lastDayOfMonth;

    setFromDate(fromDate);
    setToDate(toDate);

    let payload = {
      userId: loginResultObject.user.userId,
      fromDate: fromDate,
      toDate: toDate,
      pageNumber: 0,
      clinic_id: loginResultObject.user.clinic_Id,
    };

    setApiPayload(payload);

    BillingService.BillingRecordsList(payload)
      .then((res) => {
        setTableData(res.data);
      })
      .catch((error) => {
        console.error("Error fetching billing records:", error);
      });

    BillingService.BillingCount(payload)
      .then((res) => {
        setPage(res.data.TOTAL_COUNT_STATUS);
      })
      .catch((error) => {
        console.error("Error fetching billing records:", error);
      });
  };

  const handlePageChange = (pageNumber) => {
    apiPayload.pageNumber = pageNumber - 1;
    apiPayload.fromDate = fromDate;
    apiPayload.toDate = toDate;

    let payload = apiPayload;

    BillingService.BillingRecordsList(payload)
      .then((res) => {
        setTableData(res.data);
      })
      .catch((error) => {
        console.error("Error fetching billing records:", error);
      });

    if (apiPayload.pageNumber == 0) {
      BillingService.BillingCount(payload)
        .then((res) => {
          setPage(res.data.TOTAL_COUNT_STATUS);
        })
        .catch((error) => {
          console.error("Error fetching billing records:", error);
        });
    }
  };

  const convertUTCDateLocal = (utcDate, format = "DD/MM/YYYY, hh:mm A") => {
    const localDate = dayjs.utc(utcDate).local();
    return localDate.format(format);
  };

  const onClose = () => {
    setIsDrawerOpen(false);
  };

  const showDrawer = () => {
    setIsDrawerOpen(true);
  };

  const handleButtonSearch = () => {
    let payload = {};
    payload.patientId = searchValue;
    payload.userId = loginResultObject.user.userId;
    payload.pageNumber = 0;
    payload.fromDate = fromDate;
    payload.toDate = toDate;

    setApiPayload(payload);

    BillingService.BillingRecordsList(payload)
      .then((res) => {
        setTableData(res.data);
        setSearchValue("");
      })
      .catch((error) => {
        console.error("Error fetching billing records:", error);
      });
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    let searchValue = e.target.value;
    let payload = {};
    payload.patientName = searchValue;
    payload.userId = loginResultObject.user.userId;
    payload.pageNumber = 0;
    payload.fromDate = fromDate;
    payload.toDate = toDate;

    if (searchValue.length > 3) {
      setApiPayload(payload);
      BillingService.BillingRecordsList(payload)
        .then((res) => {
          setTableData(res.data);
          // setSearchValue("");
        })
        .catch((error) => {
          console.error("Error fetching billing records:", error);
        });
    }
    if (apiPayload.pageNumber == 0) {
      BillingService.BillingCount(payload)
        .then((res) => {
          setPage(res.data.TOTAL_COUNT_STATUS);
        })
        .catch((error) => {
          console.error("Error fetching billing records:", error);
        });
    }
  };

  const handleClick = () => {
    setIsVerticalOpen(true);
  };
  const closeCircle = () => {
    setIsVerticalOpen(false);
  };

  const handleBillingPreview = (record) => {
    if (record.status !== 1) {
      message.error("Payment is not completed");
      return;
    }
    setBillingRecord(record);
    setBillModal(true);
  };

  const closeBillingModal = () => {
    setBillModal(false);
  };
  return (
    <Layouts>
      <div className="flex flex-col h-full">
        <div className="font-bold">Payments</div>
        <div className="flex">
          <div className="md:flex justify-end items-center md:w-[60%]">
            <Input
              className="md:w-[60%]"
              placeholder="Search Patient"
              allowClear
              value={searchValue}
              onChange={handleSearch}
              suffix={
                <button className="text-white font-semibold p-2 rounded-md">
                  <FaSearch />
                </button>
              }
            />
          </div>
          <div className="flex justify-end gap-2 md:w-[40%]">
            <div>
              <DatePicker
                onChange={handleMonthFilter}
                picker="month"
                format="MMM YYYY"
                defaultValue={dayjs()}
                allowClear={false}
                className="h-[40px]"
              />
            </div>

            <div className="flex ml-4 items-center justify-end">
              <button
                className="text-white bg-brand-primaryColor font-semibold p-2 rounded-md flex items-center "
                onClick={showModal}
              >
                <FaFilter className="mr-1" />
                Filter
              </button>
            </div>
          </div>
        </div>

        <div className="w-full mt-5 scrollwidth overflow-x-scroll  rounded-md">
          <table className="w-full border scrollwidth border-gray-200 shadow-md rounded-md customTable">
            <thead className="bg-[#F5FEFA] text-[#333333] text-left text-sm font-sans font-medium">
              <tr>
                <th className="p-3 whitespace-nowrap font-sans font-semibold">
                  Patient Name
                </th>
                <th className="p-3 whitespace-nowrap font-sans font-semibold">
                  Appointment ID
                </th>
                <th className="p-3 whitespace-nowrap font-sans font-semibold">
                  Paid Date
                </th>
                <th className="p-3 whitespace-nowrap font-sans font-semibold">
                  Type of Service
                </th>
                <th className="p-3 whitespace-nowrap font-sans font-semibold">
                  Mode Of Payment
                </th>
                <th className="p-3 whitespace-nowrap font-sans font-semibold">
                  Transaction ID
                </th>
                <th className="p-3 whitespace-nowrap font-sans font-semibold">
                  Payment Status
                </th>
                <th className="p-3 whitespace-nowrap font-sans font-semibold">
                  Amount
                </th>
                <th className="p-3 whitespace-nowrap font-sans font-semibold">
                  Discount Amount
                </th>
                <th className="p-3 whitespace-nowrap font-sans font-semibold">
                  Paid Amount
                </th>
                <th className="p-3 whitespace-nowrap font-sans font-semibold">
                  Invoice
                </th>
              </tr>
            </thead>
            <tbody>
              {tableData.length > 0 ? (
                tableData.map((record, index) => (
                  <tr
                    key={index}
                    className="border-t border-gray-200 hover:bg-gray-50 font-sans font-medium text-sm text-[#333333]"
                  >
                    <td className="p-3 whitespace-nowrap border-b">
                      <div className="font-sans font-normal ">
                        <span>{record.patientName}</span>
                      </div>
                      <div className="text-[13px] font-sans">
                        {record.patientId}
                      </div>
                    </td>
                    <td className="p-3 whitespace-nowrap font-sans font-normal ">
                      {record.serviceTransId}
                    </td>
                    <td className="p-3 whitespace-nowrap font-sans font-normal">
                      {convertUTCDateLocal(record.paymentDate)}{" "}
                    </td>
                    <td className="p-3 whitespace-nowrap font-sans font-normal ">
                      {record.serviceName}
                    </td>
                    <td className="p-3 whitespace-nowrap font-sans font-normal ">
                      {record.paymode}
                    </td>
                    <td className="p-3 whitespace-nowrap font-sans font-normal ">
                      {record.transactionId}
                    </td>
                    <td className="p-3 whitespace-nowrap font-sans font-normal ">
                      <span
                        className={`px-4 py-2 rounded-md font-sans font-normal text-sm w-[104px] h-[28] ${
                          record.status
                            ? "bg-[#31E4A81A] text-green-600"
                            : "bg-[#FF60601A] text-red-600"
                        }`}
                      >
                        {record.status == 1 ? "Completed" : "Pending"}
                      </span>
                    </td>
                    <td className="p-3 whitespace-nowrap font-sans font-normal ">
                      {record.amount}
                    </td>
                    <td className="p-3 whitespace-nowrap font-sans font-normal ">
                      {record.discountAmount}
                    </td>
                    <td className="p-3 whitespace-nowrap font-sans font-normal ">
                      {record.paidAmount}
                    </td>
                    <td className="px-4 py-2 text-center  font-sans font-normal ">
                      <div className="rounded-[50%] w-8 h-8 flex items-center justify-center bg-[#DEF3F2]">
                        <img
                          src={Preview}
                          alt="Preview"
                          className="w-4 h-4 border-none cursor-pointer"
                          onClick={() => handleBillingPreview(record)}
                        />
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="text-center py-4 border">
                    No records found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="flex justify-end items-end my-4">
          <Pagination
            onChange={handlePageChange}
            defaultCurrent={1}
            total={page}
            showSizeChanger={false}
          />
        </div>
      </div>
      <Modal
        title="Payments Filter"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[]}
        style={{ width: 452, height: 200 }}
      >
        <Form
          className="formDesign w-[452px]"
          name="trigger"
          layout="vertical"
          form={form}
          onFinish={handleFinish}
        >
          <Row gutter={20} className="mt-2">
            <div className="flex">
              <Col span={12}>
                <div className="relative  w-full">
                  <input
                    type="text"
                    id="patientname"
                    placeholder=""
                    name="patientName"
                    value={formData.patientName}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value,
                      }))
                    }
                    className="w-[202px] h-[32px] p-2 border pl-4 border-[#A0A2A3] rounded-sm focus:outline-none text-[14px] font-medium font-sans peer focus:ring-0  "
                  />
                  <label
                    htmlFor="patientname"
                    className="absolute left-3 -top-3  text-[#189FAA] bg-white px-1 transition-all 
    peer-placeholder-shown:top-1   peer-placeholder-shown:-translate-y-0 peer-placeholder-shown:text-xs font-sans font-normal peer-placeholder-shown:text-gray-400 
    peer-focus:-top-2 peer-focus:text-xs peer-focus:text-[#189FAA]"
                  >
                    Patient Name
                  </label>
                </div>
              </Col>

              <Col span={12}>
                <div className="relative w-full  ">
                  <input
                    type="text"
                    id="patientId"
                    placeholder=""
                    name="patientId"
                    value={formData.patientId}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        [e.target.name]: e.target.value,
                      }))
                    }
                    className="w-[202px] h-[32px] p-2 border pl-4 border-[#A0A2A3] rounded-sm focus:outline-none text-[14px] font-medium font-sans peer focus:ring-0"
                  />
                  <label
                    htmlFor="patientId"
                    className="absolute left-3 -top-3 text-[#189FAA] bg-white px-1 transition-all 
    peer-placeholder-shown:top-1 peer-placeholder-shown:-translate-y-0 peer-placeholder-shown:text-xs font-sans font-normal peer-placeholder-shown:text-gray-400 
    peer-focus:-top-2 peer-focus:text-xs peer-focus:text-[#189FAA]"
                  >
                    Patient ID
                  </label>
                </div>
              </Col>
            </div>

            <Col span={12}>
              <div className="relative w-full mt-4">
                <input
                  type="text"
                  id="transactionId"
                  name="transactionId"
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }))
                  }
                  placeholder=""
                  value={formData.transactionId}
                  className="w-[202px] h-[32px] p-2 border pl-4 border-[#A0A2A3] rounded-sm focus:outline-none text-[14px] font-medium font-sans peer focus:ring-0"
                />
                <label
                  htmlFor="transactionId"
                  className="absolute left-3 -top-3 text-[#189FAA] bg-white px-1 transition-all 
    peer-placeholder-shown:top-1 peer-placeholder-shown:-translate-y-0 peer-placeholder-shown:text-xs font-sans font-normal peer-placeholder-shown:text-gray-400 
    peer-focus:-top-2 peer-focus:text-xs peer-focus:text-[#189FAA]"
                >
                  Transaction ID
                </label>
              </div>
            </Col>

            {/* <Col span={12}>
            <div className="relative w-[202px] h-[32px] mt-4">
  <select
    id="serviceCode"
    name="serviceCode"
    required
    value={formData.serviceCode}
    onChange={(e) =>
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }))
    }
    className="w-full h-full px-3 border border-[#A0A2A3] rounded-sm text-[14px] font-medium font-sans text-gray-400 focus:outline-none"
  >
    <option value="" disabled hidden>
      Service Type
    </option>
    <option value="option1">Option 1</option>
    <option value="option2">Option 2</option>
    <option value="option3">Option 3</option>
  </select>
</div>

            </Col> */}
          </Row>

          <Form.Item>
            <div className="flex justify-end  mt-3  border-brand-colorBorder gap-3 pt-2">
              <button
                className="h-[32px] Btnwhite rounded-sm w-[82px] border-gray-600 border-2"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                className="h-[32px] w-[118px] text-white rounded-sm"
                type="primary"
                htmlType="submit"
              >
                Filter
              </button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
      <div>
        {/* patient queue design */}
        {isVerticalOpen ? (
          <Draggable>
            <div className="draggable-container fixed top-1/2 right-2 w-14 transform -translate-y-1/2 z-50">
              <div
                className="hidden md:block relative mb-5 cursor-pointer"
                onClick={closeCircle}
              >
                <IoIosCloseCircle className="hidden md:block absolute text-red-400 mb-1 right-0 top-0" />
              </div>
              <img
                src={patientqueue}
                alt="patientqueue"
                className="cursor-pointer"
                title="Patient Queue"
                onClick={showDrawer}
              />
            </div>
          </Draggable>
        ) : (
          <div
            className="vertical"
            style={{ marginTop: "16rem" }}
            onClick={handleClick}
          >
            <p className="vertical-p">
              <div className="vertical-icon-dashboard">
                <MdKeyboardDoubleArrowUp />
              </div>
              Queue
            </p>
          </div>
        )}

        {isDrawerOpen && (
          <div className="grid justify-end mt-5">
            {isDrawerOpen && <PatientQueue onClose={onClose} />}
          </div>
        )}
        {/* patient queue design end */}

        {billModal && (
          <Modal
            title="Invoice Bill"
            width={1000}
            footer={null}
            open={billModal}
            onCancel={closeBillingModal}
          >
            <BillingPrint
              billingRecord={billingRecord}
              loginResultObject={loginResultObject}
            />
          </Modal>
        )}
      </div>
    </Layouts>
  );
}

export default Payments;
